// Copyright (c) Docugami, Inc. All rights reserved.

import { evalMetricsMachineColor } from "components/shell/presentation/AppStyles";
import { BindingProviderId } from "networking/reportsApi";
import { FeatureFlags } from "store/featureFlags/types"
import styled from "styled-components";
import { useFeatureFlag } from "./FeatureFlags"

const Legend = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
`

const ColorSpan = styled.span<{ color: string }>`
    background-color: ${props => props.color};
    margin-right: 5px;
`;

const userBindingColor = '#7591FF';
const autoCompleteColor = '#FF000080';
const xPathColor = '#00CCCCCC';
const liveQAColor = '#C285FF';
const zeroShotLiveQAColor = "#CCCCFF";
const systemColor = evalMetricsMachineColor;
const oneClickColor = "#dbffb5";
const llmQAColor = '#e28743';
const chatColor = '#FFFFB3';
const transformColor = '#FFB6C1';

type BindingProviderTypeRecord = Record<BindingProviderId, string | undefined>;
const bindingProviderColorLookup: BindingProviderTypeRecord = {
    [BindingProviderId.User]: userBindingColor,
    [BindingProviderId.LlmQA]: llmQAColor,
    [BindingProviderId.LiveQA]: liveQAColor,
    [BindingProviderId.AutoComplete]: autoCompleteColor,
    [BindingProviderId.OneClick]: oneClickColor,
    [BindingProviderId.XPath]: xPathColor,
    [BindingProviderId.Chat]: chatColor,
    [BindingProviderId.Transform]: transformColor,
    [BindingProviderId.ZeroShotLiveQA]: zeroShotLiveQAColor,
    [BindingProviderId.System]: systemColor
}

export const ChunkSourceLegend = (): JSX.Element | null => {
    const debugEnabled = useFeatureFlag(FeatureFlags.ChunkSourceDebugEnabled);

    if (!debugEnabled) {
        return null;
    }

    return (
        <Legend>
            {Object.entries(bindingProviderColorLookup).map(entry => {
                const [key, color] = entry;
                return (
                    <ColorSpan color={color ?? ''} key={key}>
                        { key }
                    </ColorSpan>
                );
            })}
        </Legend>
    );
}

export function useBindingProviderDebugColor(providerId?: BindingProviderId): string | undefined {
    const debugEnabled = useFeatureFlag(FeatureFlags.ChunkSourceDebugEnabled);
    if (!debugEnabled) {
        return undefined;
    }

    return providerId !== undefined ? bindingProviderColorLookup[providerId] : undefined;
}
